import { Component, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { Calendar } from 'primeng/calendar';
import { BaseComponent } from 'src/app/core/base/base.component';
import { Utils } from 'src/app/core/utils/khuyana.utils';
import { CommonCieModel } from 'src/app/model/common/cie';
import { ReportCieCertificateModel } from 'src/app/model/report/cie-certificate';
import { CIE_10 } from './cie.constants';
import { CieService } from './cie.service';

@Component({
  selector: 'ms-report-cie',
  templateUrl: './cie.component.html',
  styleUrls: ['./cie.component.scss'],
})
export class CieComponent extends BaseComponent {
  @ViewChild('medicalRestRange') private medicalRestRangeCalendar?: Calendar;
  readonly screen = CIE_10;
  protected setScreen = true;
  cieSuggestions: CommonCieModel[] = [];
  certificateInformation: ReportCieCertificateModel = {};
  showReportFile = false;
  reportFile?: SafeResourceUrl;
  hasMedicalRest = false;
  medicalRestDateRange?: Date[];

  constructor(
    protected service: CieService,
    protected messageService: VonMessageService
  ) {
    super();
  }

  completeSuggestions = ($event: string) => {
    this.subscriptions.push(
      this.service
        .fillCieSuggestionBy($event)
        .subscribe((cieSuggestions) => (this.cieSuggestions = cieSuggestions))
    );
  };

  calculateAge = () => {
    const { attendance, born } = this.certificateInformation;
    if (attendance && born) {
      const isValidDate = attendance!.getTime() > born!.getTime();
      if (isValidDate) {
        this.certificateInformation.age = Utils.calculateAgeStr(
          born!,
          attendance!
        );
        return;
      }
    }
    delete this.certificateInformation.age;
  };

  generateCertificate = () => {
    if (
      !this.certificateInformation.born ||
      !this.certificateInformation.attendance
    ) {
      this.messageService.addError(
        'Necesita seleccionar la fecha de nacimiento y de atención'
      );
      return;
    }
    this.service.setLoadingState();
    this.subscriptions.push(
      this.service
        .generateCertificate(this.certificateInformation)
        .subscribe((reportFile) => {
          this.showReportFile = true;
          this.reportFile = reportFile;
        })
    );
  };

  medicalRestDateSelected = () => {
    const startDate = this.medicalRestDateRange![0];
    const endDate = this.medicalRestDateRange![1];

    if (!endDate) {
      this.certificateInformation.medicalRestQuantity = 1;
      this.certificateInformation.medicalRestStartDate =
        this.certificateInformation.medicalRestEndDate = startDate;
      return;
    }

    this.certificateInformation.medicalRestQuantity = Utils.countDays(
      startDate,
      endDate
    );
    this.certificateInformation.medicalRestStartDate = startDate;
    this.certificateInformation.medicalRestEndDate = endDate;
    this.medicalRestRangeCalendar!.hideOverlay();
  };

  clearMedicalRestInformation = () => {
    this.medicalRestDateRange = undefined;
    delete this.certificateInformation.medicalRestQuantity;
    delete this.certificateInformation.medicalRestStartDate;
    delete this.certificateInformation.medicalRestEndDate;
  };

  setBornDate = (e: any) => {
    this.certificateInformation.born = e.value;
    this.calculateAge();
  };

  setAttendanceDate = (e: any) => {
    this.certificateInformation.attendance = e.value;
    this.calculateAge();
  };
}
